import React from 'react'
import { Checkbox, GraniteDataGrid } from '@tecuity/granite-ui'

const RecordUserAccessConfiguredSourceTypes = (props) => {
  const { property = {}, editItem = {}, onChange, optionsMap } = props
  const {
    AppliesToIds = [],
    PasskeyDefaultIds = [],
    RequestAccessDefaultIds = [],
    LoggedInDefaultIds = [],
    NotLoggedInDefaultIds = [],
  } = editItem

  const filterArray = (array, value) => {
    return array.includes(value) ? array.filter((v) => v !== value) : [...array, value]
  }

  const changeCheck = (id, type) => {
    onChange({
      ...editItem,
      AppliesToIds: !AppliesToIds.includes(id) ? [...AppliesToIds, id] : AppliesToIds,
      [type]: filterArray(editItem[type], id),
    })
  }
  const changeAppliesTo = (id) => {
    if (AppliesToIds.includes(id)) {
      // remove SourceTypeId from all lists.
      onChange({
        ...editItem,
        AppliesToIds: AppliesToIds.filter((v) => v !== id),
        PasskeyDefaultIds: PasskeyDefaultIds.filter((v) => v !== id),
        RequestAccessDefaultIds: RequestAccessDefaultIds.filter((v) => v !== id),
        LoggedInDefaultIds: LoggedInDefaultIds.filter((v) => v !== id),
        NotLoggedInDefaultIds: NotLoggedInDefaultIds.filter((v) => v !== id),
      })
    } else {
      onChange({
        ...editItem,
        AppliesToIds: [...AppliesToIds, id],
      })
    }
  }

  const columns = [
    {
      field: 'label',
      headerName: 'Source Type',
      disableColumnMenu: true,
      renderCell: (params) => <p style={{ fontWeight: 'bolder' }}>{params.row.label}</p>,
    },
    {
      field: 'AppliesTo',
      key: '0',
      headerName: 'Applies to Source Type',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Applies to Source Type - ${params.row.label}`}
            ariaLabel={`Applies to Source Type - ${params.row.label}`}
            checked={AppliesToIds.includes(params.row.Id)}
            onChange={() => changeAppliesTo(params.row.Id)}
          />
        )
      },
    },
    {
      field: 'UseAsPasskeyDefault',
      headerName: `Passkey Default`,
      key: '1',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Passkey Default - ${params.row.label}`}
            ariaLabel={`Use as Passkey Default - ${params.row.label}`}
            checked={PasskeyDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'PasskeyDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsRequestAccessDefault',
      key: '2',
      headerName: 'Request Access Default',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Request Access Default - ${params.row.label}`}
            ariaLabel={`Use as Request Access Default - ${params.row.label}`}
            checked={RequestAccessDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'RequestAccessDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsLoggedInDefault',
      headerName: `Logged In Default`,
      key: '1',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Logged In Default - ${params.row.label}`}
            ariaLabel={`Use as Logged In Default - ${params.row.label}`}
            checked={LoggedInDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'LoggedInDefaultIds')}
          />
        )
      },
    },
    {
      field: 'UseAsNotLoggedInDefault',
      key: '2',
      headerName: 'Logged Out Default',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            title={`Use as Logged Out Default - ${params.row.label}`}
            ariaLabel={`Use as Logged Out Default - ${params.row.label}`}
            checked={NotLoggedInDefaultIds.includes(params.row.Id)}
            onChange={() => changeCheck(params.row.Id, 'NotLoggedInDefaultIds')}
          />
        )
      },
    },
  ]
  return (
    <div key={property.k} style={{ marginBottom: '40px' }}>
      <GraniteDataGrid
        rowsPerPageOptions={[10, 25, 50]}
        getRowId={(row) => row.Id}
        selectable={false}
        compressedView={true}
        columns={columns}
        rows={optionsMap['sourceTypeOptions'] || []}
        pageSize={10}
      />
    </div>
  )
}

export default RecordUserAccessConfiguredSourceTypes

// const dummyRecordAccessUserRoleDTO = {
//   RecordAccessUserRoleId: 10,
//   IsActive: true,
//   CanViewInMyRecords: true,
//   CanViewHistory: false,
//   CanRequestAccess: true,
//   CanManageUserAccess: false,
//   CanFileAmendments: true,
//   CanFileSpecialAmendments: false,
//   CanFileOrderRequests: true,
//   ConfiguredSourceTypes: {
//     0: {
//       UseAsPasskeyDefault: true,
//       UseAsRequestAccessDefault: false,
//       UseAsLoggedInDefault: true,
//       UseAsNotLoggedInDefault: false,
//     },
//     169: {
//       UseAsPasskeyDefault: false,
//       UseAsRequestAccessDefault: true,
//       UseAsLoggedInDefault: false,
//       UseAsNotLoggedInDefault: true,
//     },
//     514: {
//       UseAsPasskeyDefault: true,
//       UseAsRequestAccessDefault: false,
//       UseAsLoggedInDefault: true,
//       UseAsNotLoggedInDefault: false,
//     },
//   },
// }
